import { render } from "./MarketplaceAddListing.vue?vue&type=template&id=0a8a5d85&scoped=true"
import script from "./MarketplaceAddListing.vue?vue&type=script&lang=js"
export * from "./MarketplaceAddListing.vue?vue&type=script&lang=js"

import "./MarketplaceAddListing.vue?vue&type=style&index=0&id=0a8a5d85&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/energy-hub-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a8a5d85"]])

export default __exports__